// src/common.types.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["info"] = "info";
  LogLevel2["warn"] = "warn";
  LogLevel2["error"] = "error";
  LogLevel2["debug"] = "debug";
  LogLevel2["trace"] = "trace";
  LogLevel2["fatal"] = "fatal";
  return LogLevel2;
})(LogLevel || {});
var LogLevelPriority = {
  ["trace" /* trace */]: 10,
  ["debug" /* debug */]: 20,
  ["info" /* info */]: 30,
  ["warn" /* warn */]: 40,
  ["error" /* error */]: 50,
  ["fatal" /* fatal */]: 60
};
var LogLevelPriorityToNames = {
  10: "trace" /* trace */,
  20: "debug" /* debug */,
  30: "info" /* info */,
  40: "warn" /* warn */,
  50: "error" /* error */,
  60: "fatal" /* fatal */
};
export {
  LogLevel,
  LogLevelPriority,
  LogLevelPriorityToNames
};
